<script>
export default {
  name: "Earning",
  data() {
    return {
      chartOptions: {
        chart: {
          height: 200,
          type: "radialBar",
          offsetY: -10,
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: "13px",
                color: undefined,
                offsetY: 60,
              },
              value: {
                offsetY: 22,
                fontSize: "16px",
                color: undefined,
                formatter: function (val) {
                  return val + "%";
                },
              },
            },
          },
        },
        colors: ["#556ee6"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91],
          },
        },
        stroke: {
          dashArray: 4,
        },
        labels: ["Utilization Series"],
      },
      series: [67],
      totalAllocations: {
          allocation: {
          utilization: 0,
          allocation: 0,
          percentageFromLastYear: 0,
        }
      }
    };
  },
  methods: {
    setAllocation(allocations){
      this.series = [allocations.allocation.utilization];
      this.totalAllocations = allocations;
    },
    goToBudgetItem(){
      this.$router.push({ name: 'myBudgetItemResources' });
    }
  }
};
</script>

<template>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-4">Total Allocations</h4>
        <div class="row">
          <div class="col-sm-6">
            <p class="text-muted">This year</p>
            <h3>{{formatCurrency(totalAllocations.allocation.allocation)}}</h3>
            <p class="text-muted">
              <span class="text-success me-2" v-if="totalAllocations.allocation.percentageFromLastYear > 0">
                {{totalAllocations.allocation.percentageFromLastYear}}%
                <i class="mdi mdi-arrow-up"></i>
              </span>
              <span v-else class="text-warning me-2">
                {{totalAllocations.allocation.percentageFromLastYear}}%
                <i class="mdi mdi-arrow-down"></i>
              </span>
              From last year 
            </p>

            <div class="mt-4">
              <a href="javascript: void(0);" class="btn btn-primary btn-sm" @click="goToBudgetItem">
                View More
                <i class="mdi mdi-arrow-right ms-1"></i>
              </a>
            </div>
          </div>
          <div class="col-sm-6">
            <!-- Chart -->
            <apexchart
              class="apex-charts"
              type="radialBar"
              height="200"
              dir="ltr"
              :series="series"
              :options="chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
</template>